import React, { ReactElement } from 'react';
import Collapsible from 'react-collapsible';
import Icon from 'atomic/icon';
import Circle from 'atomic/circle/circle';
import generateElementId from 'helpers/generate-element-id';

import './filter-group.scss';

const FilterGroup: React.FC<{
    pk?: number;
    name: string;
    open: boolean;
    position: number;
    description?: string;
    operator?: string;
    selected: number;
    children: React.ReactNode;
}> = ({ name, position, description, open, children, selected }): ReactElement | null => (
    <Collapsible
        tabIndex={0}
        trigger={<>
            {name}
            { description && (
                <Icon
                    size={20}
                    name="info"
                    title={description}
                    className="filter-section__trigger-description"
                />
            )}
            {selected > 0 && (
                <Circle
                    className="filter-section__trigger-total-checked"
                    tag="span"
                    color="white"
                    size={20}
                    border="primary"
                    hoverEffect={false}
                    background="primary"
                >
                    <span>
                        {selected}
                    </span>
                </Circle>
            )}
        </>}
        open={open}
        contentElementId={`collapsible-content-p${position}-${generateElementId(name)}`}
        triggerElementProps={{ id: generateElementId(name) }}
        classParentString="filter-section"
        contentInnerClassName="filter-section-content"
        transitionTime={250}
        key={name}
    >
        {children}
    </Collapsible>
);

export default FilterGroup;
